import { SPOILER_TYPE, POLL_TYPE, TIPTAP_POLL_TYPE, } from 'wix-rich-content-common';
export const getAbsoluteUrl = (url) => url.substring(0, 5).includes('http') ? url : 'http://' + url;
export const hasPlugin = (pluginType, plugins) => !!(plugins === null || plugins === void 0 ? void 0 : plugins.some(plugin => plugin.type === pluginType));
export const getPluginConfig = (pluginType, plugins) => { var _a; return ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.find(plugin => plugin.type === pluginType)) === null || _a === void 0 ? void 0 : _a.config) || {}; };
export const extractPluginsConfig = (plugins, helpers) => {
    let mergedConfig = {};
    plugins === null || plugins === void 0 ? void 0 : plugins.forEach(plugin => {
        const { type, config } = plugin;
        if (Object.keys(config).length !== 0) {
            mergedConfig = Object.assign(Object.assign({}, mergedConfig), { [type]: config });
        }
        if (type === SPOILER_TYPE && helpers) {
            mergedConfig[type].onViewerAction = helpers.onViewerAction;
        }
    });
    return { config: mergedConfig };
};
export const hasPollsPluginInContent = (content) => {
    if (!content) {
        return false;
    }
    const nodes = content.nodes;
    return nodes.some(node => [POLL_TYPE, TIPTAP_POLL_TYPE].includes(node.type));
};
//# sourceMappingURL=utils.js.map